import "./plan-import-validation.css";
import "./production-material-evidence.css";
import "./plan-workbook-editor.css";
import { useProductionPlanImportWorkspace } from "./plan-import/useProductionPlanImportWorkspace";
import { ProductionPlanImportView } from "./plan-import/ProductionPlanImportView";

export function ProductionPlanImport({notify, onDraftImported}: {notify?: (message: string) => void; onDraftImported: (weekStart: string) => void}) {
  const workspace = useProductionPlanImportWorkspace({notify, onDraftImported});
  return <ProductionPlanImportView workspace={workspace} />;
}
